import { DatePicker as MuiDatePicker, DatePickerProps, PickerValidDate } from "@mui/x-date-pickers";

interface Props<TDate extends PickerValidDate, TEnableAccessibleFieldDOMStructure extends boolean = false>
    extends DatePickerProps<TDate, TEnableAccessibleFieldDOMStructure> {
    required?: boolean;
}

export function DatePicker<TDate extends PickerValidDate, TEnableAccessibleFieldDOMStructure extends boolean = false>({
    required,
    ...props
}: Props<TDate, TEnableAccessibleFieldDOMStructure>) {
    return (
        <MuiDatePicker
            {...props}
            slotProps={{ ...props.slotProps, textField: { ...props.slotProps?.textField, required } }}
        />
    );
}
